import React from 'react'
import convertUnit from 'lib/unit'
import {IconCustomProps} from '../Icon'

export default function IconFotoyuLogo({
  width = convertUnit(80),
  height = convertUnit(80),
  fill = 'none',
  ...props
}: IconCustomProps) {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 80 80">
      <rect width="80" height="80" rx="16" fill="#7E4890" />
      <path
        d="M16.7723 33.7644C17.0295 32.9062 17.9337 32.419 18.792 32.6762L24.1107 34.2702L23.5614 36.1032L18.3668 34.5464L16.569 40.5454C16.3118 41.4036 15.4075 41.8909 14.5493 41.6337L14.4251 41.5964L16.7723 33.7644Z"
        fill="#A6F655"
      />
      <path
        d="M22.8631 45.5678C22.6059 46.4261 21.7017 46.9133 20.8434 46.6561L15.4052 45.0263L15.965 43.1583L21.1327 44.707L22.92 38.743C23.1773 37.8848 24.0815 37.3975 24.9398 37.6547L25.2103 37.7358L22.8631 45.5678Z"
        fill="#A6F655"
      />
      <path
        d="M64.8413 32.7688L59.6058 40.6303C59.6058 40.6303 59.6534 44.8388 59.6058 45.0365C59.2158 46.655 57.5203 46.655 57.5203 46.655V40.6689L51.8959 32.7688C51.8959 32.7688 54.0336 32.42 54.7011 33.138C55.0814 33.5471 58.6017 38.7379 58.6017 38.7379C58.6017 38.7379 61.6558 33.8363 62.1547 33.138C62.6537 32.4397 64.8413 32.7688 64.8413 32.7688Z"
        fill="white"
      />
      <path
        d="M77.1875 32.9567V41.3886C77.1875 42.4003 76.9517 43.3096 76.48 44.1164C76.021 44.9104 75.3836 45.5379 74.5677 45.999C73.7645 46.4472 72.8402 46.6713 71.7949 46.6713C70.7622 46.6713 69.838 46.4472 69.0221 45.999C68.2062 45.5379 67.5623 44.9104 67.0907 44.1164C66.6317 43.3096 66.4022 42.4003 66.4022 41.3886V32.6867C66.4022 32.6867 68.204 32.5535 68.4675 34.2179C68.4675 34.6839 68.4675 41.2157 68.4675 41.2157C68.4675 41.8816 68.6205 42.4771 68.9264 43.0022C69.2452 43.5273 69.6595 43.9371 70.1694 44.2316C70.6794 44.5262 71.2212 44.6735 71.7949 44.6735C72.4068 44.6735 72.9741 44.5262 73.4968 44.2316C74.0195 43.9371 74.4338 43.5273 74.7398 43.0022C75.0585 42.4771 75.2178 41.8816 75.2178 41.2157C75.2178 41.2157 75.101 34.5296 75.2178 34.2179C75.817 32.6201 77.1875 32.9567 77.1875 32.9567Z"
        fill="white"
      />
      <path
        d="M50.7483 39.5828C50.7483 43.8881 48.1683 46.4976 44.6801 46.4976C41.1786 46.4976 38.6052 43.8816 38.6052 39.5828C38.6052 35.2775 41.1786 32.668 44.6801 32.668C48.1683 32.668 50.7483 35.2775 50.7483 39.5828ZM48.7344 39.5828C48.7344 36.3029 46.9968 34.5216 44.6801 34.5216C42.3568 34.5216 40.6258 36.3029 40.6258 39.5828C40.6258 42.8627 42.3568 44.644 44.6801 44.644C46.9968 44.644 48.7344 42.8627 48.7344 39.5828Z"
        fill="white"
      />
      <path
        d="M30.8764 46.5077V34.7379H27.0059V32.6841H37.2912C37.2912 32.6841 37.0855 34.7379 36.057 34.7379C35.0284 34.7379 33.0092 34.7379 33.0092 34.7379C33.0092 34.7379 33.0092 43.2438 33.0092 44.958C33.0092 46.6722 30.8764 46.5077 30.8764 46.5077Z"
        fill="white"
      />
      <path
        d="M3.75 46.3245V34.4433C3.75 33.4717 4.53761 32.6841 5.50918 32.6841H12.5968V34.7107H5.85452V38.491H11.7199V40.5176H5.85452V44.5654C5.85452 45.5369 5.06691 46.3245 4.09534 46.3245H3.75Z"
        fill="white"
      />
    </svg>
  )
}
